import useSWR from "swr"

import {
    AppError,
    parseAndThrowAppError,
} from "../../../../errors/errorProcessors"
import { getClientProtected } from "../../clients/clients"
import { getSchemaMapper } from "../../mappers/singleApplication/getSchemaMapper"
import { IGetSchemaMapper } from "../../types/singleApplication/getSchemaTypes"
import { GET_SCHEMA } from "../../urls/hybrid"

interface IGetSchema {
    data: IGetSchemaMapper | undefined
    isLoading: boolean
    error: AppError | undefined
}

/**
 * Hook for fetching the application schema. Revalidation is disabled.
 * @returns {IGetSchema} - data, loading and error states.
 */
const useGetSchema = (lcts: string[]): IGetSchema => {
    const { data, error, isLoading } = useSWR(
        GET_SCHEMA(lcts),
        async (url: string): Promise<IGetSchemaMapper> => {
            try {
                const res = await getClientProtected(url)
                return getSchemaMapper.map(res)
            } catch (err) {
                throw parseAndThrowAppError(err)
            }
        },
        { revalidateOnFocus: false, revalidateOnReconnect: false }
    )

    return {
        data,
        isLoading,
        error,
    }
}

export default useGetSchema
